import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { App } from "../../../../routes/Constants";
import useRoles from "../../../../hooks/useRoles";

const DrugToPrescribe = ({
  registerPatient,
  selectTypeOfDrug,
  drugToPrescribe,
}) => {
  const navigate = useNavigate();
  const { storageData } = useRoles();

  const activeDrugs = (drugToPrescribe || []).filter(
    (drug) => drug?.can_renew_registration === true && drug?.product_active === true
  );

  const inactiveDrugs = (drugToPrescribe || []).filter(
    (drug) => drug?.product_active === true && !drug?.can_renew_registration
  );

  const goToProfile = () => {
    navigate(`${App.PROFILE_DEFAULT}` + storageData.registration_number);
  };

  return (
    <div className="space-y-4" data-testid="patient-initiation-drug-to-prescribe">
      <h1
        className="text-lg font-semibold text-[#00567a] my-4"
        data-testid="patient-initiation-drug-title"
      >
        Please select the drug to prescribe
      </h1>

      <hr className="border-t border-[#768692]" />
      

      <div
        className="mt-8 mb-3 min-h-125 space-y-4"
        data-testid="patient-initiation-drug-list"
        role="group"
        aria-label="Drug to prescribe"
      >
        {activeDrugs.map((drug) => {
          const isSelected = registerPatient?.drug === drug?.product_name;
          return (
            <div key={drug.product_id}>
              <button
                className={
                  "h-11.5 w-full rounded-full px-5 text-lg font-bold " +
                  (isSelected
                    ? "bg-[#00567a] text-white"
                    : "border-0 bg-[rgba(0,114,206,0.25)] text-[#181c32] shadow-[0_0_10px_rgba(0,0,0,0.1)]")
                }
                onClick={() =>
                  selectTypeOfDrug(drug?.product_name, drug?.product_id)
                }
                data-testid={`patient-initiation-drug-option-${drug.product_id}`}
              >
                {drug?.product_name}
              </button>
            </div>
          );
        })}

        {inactiveDrugs.map((drug) => (
          <div key={drug.product_id}>
            <button
              className="mb-11.25 w-full rounded-full border-0 bg-[#8c8c8c] px-5 py-2 text-left text-[#181c32] shadow-[0_0_10px_rgba(0,0,0,0.1)]"
              onClick={() => goToProfile()}
              data-testid={`patient-initiation-drug-inactive-${drug.product_id}`}
            >
              <p className="m-2 rounded-full border-0 text-lg leading-5.5 font-bold text-white">
                {drug?.product_name}
              </p>
              <p className="m-0 mt-3.75 text-[#da291c]">
                {drug.can_register || drug.can_re_register
                  ? "Requires registration, click the drug to register"
                  : drug.pending_activation === true
                  ? "Medication disabled for you"
                  : ""}
              </p>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

DrugToPrescribe.propTypes = {
  registerPatient: PropTypes.object,
  selectTypeOfDrug: PropTypes.func,
  drugToPrescribe: PropTypes.array,
};

export default DrugToPrescribe;
